import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { generateRandomKey } from '@app/utils/utils';

const wrapInTag = (JSXTagName, text, props) => (
  <JSXTagName key={generateRandomKey()} {...props}>
    {text}
  </JSXTagName>
);

const createLinkElement = ([[linkMarkdown]]) => {
  const mdLinkRegx = /\[(.+)\]\((.+)\)/i;

  const [, textPart, linkPart] = linkMarkdown.match(mdLinkRegx);
  const [href, atributes = ''] = linkPart.split('|');

  const linkAtributes = atributes
    .replace(/,\s+/g, ',')
    .split(',')
    .map(attr => {
      const [key, value] = attr.split('=');
      return key && value ? { [key]: value } : {};
    });

  return wrapInTag('a', textPart, Object.assign({ href }, ...linkAtributes));
};

const defaultFormatting = {
  br: <br key={generateRandomKey()} />,
  i: (...text) => wrapInTag('i', text),
  b: (...text) => wrapInTag('b', text),
  u: (...text) => wrapInTag('u', text),
  p: (...text) => wrapInTag('p', text),
  li: (...text) => wrapInTag('li', text),
  a: (...text) => createLinkElement(text),
  span: (...text) => wrapInTag('span', text),
};

const LocalizedText = ({ id = 'qau-empty-text', tagName = '', values = {} }) => (
  <FormattedMessage id={id} values={{ ...defaultFormatting, ...values }} tagName={tagName} defaultMessage=" "/>
);

LocalizedText.propTypes = {
  id: PropTypes.string.isRequired,
  tagName: PropTypes.string,
  values: PropTypes.object,
};

export default LocalizedText;
